module.exports = __webpack_public_path__ + "img/mapa-min.4b1d8699.png";